<template>
  <div class="sensor-setup" :class="{inline: inline}">
    <div class="triangle"></div>
    <div class="title">
      <span>{{ $t(`metrics.${sensor.name.toLowerCase()}`) }}</span>
    </div>
    <div class="slider">
      <vue-slider
        v-model="values"
        tooltip="always"
        :data="customData"
        :enable-cross="false"
        :min="Number(sensor.minValue)"
        :max="Number(sensor.maxValue)"
        :value="[sensor.minCrit, sensor.maxCrit]"
        :tooltip-formatter="val => `${val}${sensor.unit}`"
      ></vue-slider>
    </div>
    <div v-if="!inline" class="footer">
      <button @click="applyNewValues">{{ $t('buttons.apply') }}</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SensorSetup',
  props: {
    sensor: {
      type: Object,
      // validator: obj => {
      //   return Object.keys(obj).every(field =>
      //     ['name', 'label', 'unit', 'min', 'max'].includes(field),
      //   );
      // },
    },
    inline: {
      type: Boolean,
      dafault: false,
    },
  },
  data() {
    return {
      values: [this.sensor.minCrit, this.sensor.maxCrit],
    };
  },
  computed:{
    customData(){
      return this.sensor.maxValue > 1000 ? [0, 1, 3, 20, 50, 80, 100, 150, 320, 500, 1000, 10000, 25000, 32000, 100000, 120000] : null;
    }
  },
  watch: {
    values(newValues, oldValues) {
      if (this.inline) {
        this.$emit('onChange', { sensor_id: this.sensor.sensorId, values: newValues });
      }
    },
  },
  methods: {
    applyNewValues() {
      this.$emit('onChange', { id: this.sensor.id, minCrit: this.values[0], maxCrit: this.values[1] });
    },
  },
};
</script>

<style lang="scss" scoped>
.sensor-setup {
  padding: 2px 15px;
  position: absolute;
  z-index: 2;
  top: 115%;
  left: -8.9rem;
  width: 24rem;
  background-color: #fff;
  box-shadow: 0 0.5rem 1.5rem 0 rgba(37, 44, 97, 0.15), 0 0.2rem 0.4rem 0 rgba(93, 100, 148, 0.2);
    @media only screen and (max-width: 1199px) {
        left: -14.9rem;
    }

  &.inline {
    position: initial;
    display: inline-block;
    width: 24rem;
    margin-right: 2rem;
    box-shadow: none;

    .triangle {
      display: none;
    }
  }

  .triangle {
    position: absolute;
    top: -1.2rem;
    left: 0;
    right: 0;
    margin: 0 auto;
    width: 0;
    height: 0;
    border-left: 1rem solid transparent;
    border-right: 1rem solid transparent;
    border-bottom: 1.2rem solid white;
  }

  .title {
    padding: 1rem;
    color: $grey;
    font-weight: 500;
    span {
      color: $dark;
    }
  }

  .slider {
    margin-top: 1.5rem;
    padding: 0 2.2rem;
  }

  .footer {
    padding: 1rem;
    display: flex;
    button {
      background-color: $company-color;
      color: white;
      margin-left: auto;
      border: none;
      font-weight: 600;
      font-size: 1rem;
      padding: 0.7rem 1.2rem;
      border-radius: 0.5rem;
      cursor: pointer;
      transition: all 0.4s;

      &:hover {
        background-color: darken($company-color, 10%);
      }
    }
  }
}
</style>
